import React from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePickerView } from "@mui/lab/DatePicker/shared";
import { Box, Paper, Stack, Tabs, TextField, Typography, Tab, withStyles } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { ColorUtils } from "../../utils/ColorUtils";

interface Props {
  elevation?: number;
  rightContent?: JSX.Element;
  children?: React.ReactNode;
  selectedTab: number;
  handleTabChange: (event: React.SyntheticEvent, tab: number) => void;
}

export const StaffTabsToolbar = ({ elevation = 0, rightContent, children, selectedTab, handleTabChange }: Props) => {
  return (
    <>
      <Paper elevation={elevation} style={{ padding: "10px" }}>
        <Tabs value={selectedTab} onChange={handleTabChange} style={{ paddingBottom: "0.5em" }} sx={{'& .MuiTabs-indicator': {
                backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING,
              },}}>
          <Tab
            label="Staff Report"
            sx={{
              fontSize: "1.2em",
              textTransform: "none",
              fontWeight: "bold",
              "&.Mui-selected": {
                color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING,
              },
              
            }}
          />
          <Tab
            label="Available staff for new projects"
            sx={{
              fontSize: "1.2em",
              textTransform: "none",
              fontWeight: "bold",
              "&.Mui-selected": {
                color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING,
              }
            }}
          />
        </Tabs>
      </Paper>
      <Box>
        <Paper elevation={elevation} style={{ paddingBottom: "5px", marginTop: ".5rem" }}>
          <Box style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", justifyContent: "space-between" }}>
            {!!rightContent && rightContent}
          </Box>

          <div style={{ display: "flex", marginBottom: "0rem", alignItems: "flex-start", marginTop: "0px" }}>{children}</div>
        </Paper>
      </Box>
    </>
  );
};

interface DatePickerWrapperProps {
  children: React.ReactNode;
}

export const DatePickerWrapper: React.FC<DatePickerWrapperProps> = ({ children }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack style={{ display: "contents" }}>{children}</Stack>
    </LocalizationProvider>
  );
};

interface DatePickerProps {
  views: DatePickerView;
  minDate?: Date;
  maxDate?: Date;
  label: string;
  value: Date | null;
  inputFormat: string;
  onChange: (value: Date | null) => void;
}

export const DatePickerComponent: React.FC<DatePickerProps> = ({ onChange, value, views, label, inputFormat, ...rest }) => {
  return (
    <DatePicker
      views={[views]}
      label={label}
      value={value}
      inputFormat={inputFormat}
      onChange={(value) => onChange(value)}
      renderInput={(params: any) => (
        <TextField {...params} style={{ marginRight: "10px", textAlignLast: "right", width: 200 }} helperText={null} size="small" />
      )}
      {...rest}
    />
  );
};
